// ----------------------------------------- //
// Dynamic Delivery Date - Product Page //
// ----------------------------------------- //

document.addEventListener("DOMContentLoaded", function () {
  // Function to add days to a date
  function addDays(date, days) {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  let currentDate = new Date(); // Current date and time in UTC
  let currentDanishTime = new Date(
    currentDate.toLocaleString("en-US", { timeZone: "Europe/Copenhagen" })
  );

  // Determine first and second dates by adding 1 and 2 days respectively
  let firstDate = addDays(currentDanishTime, 1);
  let secondDate = addDays(currentDanishTime, 2);

  // Format dates as "MMM DD"
  const options = { month: "short", day: "2-digit" };
  const firstDateFormatted = firstDate.toLocaleDateString("en-US", options);
  const secondDateFormatted = secondDate.toLocaleDateString("en-US", options);

  // Update the paragraph content
  let paragraph = document.getElementById("date-info");
  paragraph.textContent = `${firstDateFormatted} - ${secondDateFormatted}`;
});